import { useState, useEffect } from "react";
import { ResourceDWR } from "../../../dto/ResourceDWR";
import { HoldingsInformation } from "../../../dto/HoldingsInformation";
import { ResourceView } from "../../../dto/ResourceView";
import { useAvailability } from "../../../contexts/AvailabilityContext";

export interface ItemAvailability {
  resourceId: number;
  itemIdentifier: string;
  available: boolean;
  status: string;
  dueDate: any; // TODO: type
  dueDateString: string;
  statusCode: string;
  modStatus: any; // TODO: type
  nonCirculating: boolean;
  onOrder: boolean;
}

export interface HostSystemDiag {
  hostSystemFailure: any;
  methodSupported: boolean;
  validHostUser: boolean;
  validSessionUser: boolean;
}

export interface ItemAvailabilityReturn {
  hostSystemDiag: HostSystemDiag;
  itemAvailabilities: ItemAvailability[];
}

export const useItemAvailability = (
  holdings: HoldingsInformation[],
  resource: ResourceDWR | ResourceView
) => {
  const [itemAvailability, setItemAvailability] = useState<
    Map<HoldingsInformation["barcode"], ItemAvailability>
  >(new Map());
  const [ready, setReady] = useState<boolean>(false);
  const { getAvailabilityForHoldings } = useAvailability();

  useEffect(() => {
    if ((holdings ?? []).length === 0) {
      setReady(true);
      return;
    }

    getAvailabilityForHoldings(resource.id, holdings).then(
      (itemAvailabilities) => {
        setItemAvailability(
          itemAvailabilities.reduce((acc, availability) => {
            acc.set(availability.itemIdentifier, availability);
            return acc;
          }, new Map() as Map<ItemAvailability["itemIdentifier"], ItemAvailability>)
        );
        setReady(true);
      }
    );
  }, [holdings, resource]);

  return { itemAvailability, ready };
};
